<!-- Sidebar izquierdo con formas decorativas en desktop -->

<!-- Flecha de atrás centrada -->
<!--<button
  class="absolute left-1/2 top-4 md:top-6 transform -translate-x-1/2 bg-transparent border-none cursor-pointer p-0 w-10 h-10 flex items-center justify-center transition-opacity duration-300 hover:opacity-70 z-20"
  type="button"
  (click)="goBack()"
>
  <i class="text-white text-2xl md:text-3xl pi pi-arrow-left"></i>
</button>
-->

<!-- Círculo con número dinámico -->
<div
  class="absolute right-4 top-1/2 md:left-1/2 md:top-[200px] transform -translate-y-1/2 md:-translate-x-1/2 md:translate-y-0 w-14 h-14 md:w-16 md:h-16 bg-[#596AFE] rounded-full flex items-center justify-center"
>
  <span class="text-white font-inter text-xl md:text-2xl font-bold">{{
    circleNumber
  }}</span>
</div>

<!-- Formas decorativas simplificadas con CSS -->
<div class="hidden md:block absolute left-[-50px] top-[300px] z-10 opacity-80">
  <div class="w-[120px] h-[200px] bg-[#556BFF] opacity-50 rounded-[40px]"></div>
</div>

<div class="hidden md:block absolute left-[-30px] bottom-[0px] z-10 opacity-60">
  <div class="w-[100px] h-[150px] bg-[#556BFF] opacity-40 rounded-[30px]"></div>
</div>
